
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#2B5DEA","d":"M0 0h900v600H0V0z"}}),_c('path',{attrs:{"fill":"#FFDF29","d":"M0 100h900v400H0V100z"}}),_c('path',{attrs:{"fill":"#D70000","d":"M0 150h900v300H0V150z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"}}),_c('path',{attrs:{"d":"M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M346.3 254.3h21v91.3h-21zM398.2 254.3h21v91.3h-21z"}}),_c('path',{attrs:{"d":"M477.8 254.3h21v91.3h-21zM529.7 254.3h21v91.3h-21z"}})])
          )
        }
      }
    